import { useMemo } from "react";
import { useSelector } from "react-redux";
import { hasAllMandatoryQuestionsAnswered } from "../utils/mandatoryQuestions";

const useActivityQuestions = () => {
    const state = useSelector((state) => state.activityQuestions);

    const endToEndTypes = useMemo(
        () =>
            (process.env.REACT_APP_END_TO_END_FOLLOWUP_TYPES || "")
                .split(",")
                .map((s) => parseInt(s.trim(), 10))
                .filter((n) => !isNaN(n)),
        [],
    );

    return {
        activityQuestions: state,
        hasAllMandatoryQuestionsAnswered: (followUpUUID) => hasAllMandatoryQuestionsAnswered(state.questions[followUpUUID]?.mappedQuestions),
        endToEndTypes,
    };
};

export default useActivityQuestions;
